import React, { useState, useEffect } from 'react';
import { ChevronDown, MapPin } from 'lucide-react';
import { Button } from '../ui/button';

const GolfHero = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section className="relative h-screen overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className={`w-full h-full object-cover transition-transform duration-[15s] ease-out ${
            isLoaded ? 'scale-110' : 'scale-100'
          }`}
          onLoadedData={() => setIsLoaded(true)}
        >
          <source src="/video/hero-bg.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f2419]/70 via-[#1a3c2a]/50 to-[#0f2419]/80" />
      </div>

      {/* Decorative Gold Lines */}
      <div className="absolute top-20 left-10 w-px h-32 bg-gradient-to-b from-transparent via-[#c9a962] to-transparent opacity-60" />
      <div className="absolute top-20 right-10 w-px h-32 bg-gradient-to-b from-transparent via-[#c9a962] to-transparent opacity-60" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <div className={`max-w-4xl mx-auto text-center transition-all duration-1000 delay-300 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}>
            {/* Location Badge */}
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/5 backdrop-blur-md rounded-full border border-[#c9a962]/30 mb-8">
              <MapPin className="w-4 h-4 text-[#c9a962]" />
              <span className="text-white/90 text-sm font-montserrat tracking-widest uppercase">Songon, Côte d'Ivoire</span>
            </div>

            {/* Decorative Line */}
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-[#c9a962] to-transparent mx-auto mb-8" />

            {/* Main Title */}
            <h1 className="font-playfair text-5xl md:text-6xl lg:text-8xl text-white mb-6 tracking-tight leading-[1.1]">
              Le Golf
              <span className="block text-[#c9a962] italic">de Songon M'braté</span>
            </h1>

            {/* Tagline */}
            <p className="font-playfair text-xl md:text-2xl text-[#c9a962] italic mb-6">
              Golf Club • Résidences d'Exception
            </p>

            {/* Subtitle - Minimal */}
            <p className="font-montserrat text-lg text-white/60 font-light mb-12 max-w-xl mx-auto">
              Un projet d'exception par One Green Dev
            </p>

            {/* Single CTA */}
            <Button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-gold px-12 py-6 text-sm uppercase tracking-widest rounded-none"
            >
              Présentation privée
            </Button>
          </div>
        </div>

        {/* Bottom Stats Bar - Data from documents */}
        <div className="absolute bottom-0 left-0 right-0 bg-[#0f2419]/90 backdrop-blur-md border-t border-[#c9a962]/20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
            <div className="grid grid-cols-4 gap-6">
              {[
                { value: '9', label: 'Trous' },
                { value: 'Par 36', label: 'Parcours' },
                { value: '300m', label: 'Practice' },
                { value: '2027', label: 'Livraison' }
              ].map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="font-playfair text-2xl md:text-3xl text-[#c9a962] mb-1">
                    {stat.value}
                  </div>
                  <div className="font-montserrat text-white/50 text-[10px] md:text-xs tracking-widest uppercase">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <button 
          onClick={scrollToContent}
          className="absolute bottom-36 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[#c9a962]/60 hover:text-[#c9a962] transition-colors cursor-pointer"
        >
          <ChevronDown className="w-5 h-5 animate-bounce" />
        </button>
      </div>
    </section>
  );
};

export default GolfHero;
